import { docsDartEditBody, docsDartIntro, docsDartMappingBody, docsDartMappingTitle, docsDartRenderBody, docsDartThemingBody, docsPackagesInstallTitle } from 'Clepit/translations';
import type { SupportedLanguage } from '@bomdisoft/translations';
import type { EditorData } from '@clepit/core';

const EDIT_SAMPLE = `import 'package:clepit_core/clepit_core.dart';

final controller = EditorController(
  initial: EditorData.fromJson(documentJson),
);

Editor(
  controller: controller,
  config: EditorConfig(
    onChange: (data) => save(data),
  ),
);`;

const RENDER_SAMPLE = `Renderer(
  config: RendererConfig(data: document),
);`;

export const buildDart = (language: SupportedLanguage): EditorData => ({
  blocks: [
    { data: { html: 'clepit_core', level: 'h1' }, type: 'header' },
    { data: { html: docsDartIntro[language] }, type: 'paragraph' },
    {
      data: {
        html: '<a href="https://pub.dev/packages/clepit_core" target="_blank" rel="noopener noreferrer">pub.dev: clepit_core</a> · <a href="https://www.npmjs.com/package/@clepit/core" target="_blank" rel="noopener noreferrer">npm: @clepit/core</a>',
      },
      type: 'paragraph',
    },

    { data: { html: docsPackagesInstallTitle[language], level: 'h2' }, type: 'header' },
    { data: { code: 'flutter pub add clepit_core', language: 'shell', showCopy: true }, type: 'code' },

    { data: { html: 'Editor', level: 'h2' }, type: 'header' },
    { data: { html: docsDartEditBody[language] }, type: 'paragraph' },
    { data: { code: EDIT_SAMPLE, language: 'dart', showCopy: true }, type: 'code' },

    { data: { html: 'Renderer', level: 'h2' }, type: 'header' },
    { data: { html: docsDartRenderBody[language] }, type: 'paragraph' },
    { data: { code: RENDER_SAMPLE, language: 'dart', showCopy: true }, type: 'code' },

    { data: { html: 'ClepitTheme', level: 'h2' }, type: 'header' },
    { data: { html: docsDartThemingBody[language] }, type: 'paragraph' },

    { data: { html: docsDartMappingTitle[language], level: 'h2' }, type: 'header' },
    { data: { html: docsDartMappingBody[language] }, type: 'paragraph' },
    {
      data: {
        data: [
          ['TypeScript', 'Dart'],
          ['Editor', 'Editor'],
          ['Renderer', 'Renderer'],
          ['StyleManager', 'ThemeExtension<ClepitTheme> + ThemeData'],
          ['Tool', 'BlockTool / InlineTool'],
          ['Block<T>', 'sealed class Block'],
          ['EditorAPI', 'EditorApi + BlocksApi, SelectionApi'],
        ],
      },
      type: 'table',
    },
  ],
  time: 1_745_000_000_000,
  version: '1.0.0',
});
